import React from 'react';

const Footer = () => {
  return (
    <footer className="border-t border-white/10 bg-gray-950/40">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
          {/* Brand */}
          <div>
            <div className="text-lg font-serif text-porcelain-white">
              Wisdom Nexus
            </div>
            <p className="mt-2 text-sm text-porcelain-white/60 max-w-sm">
              Part of the Wisdom Series — cultural tools for modern life.
            </p>
          </div>

          {/* Internal */}
          <div>
            <div className="text-xs font-mono tracking-widest text-porcelain-white/50 uppercase">
              Explore
            </div>
            <ul className="mt-3 space-y-2 text-sm">
              <li className="text-porcelain-white/70">Daily Wisdom</li>
              <li className="text-porcelain-white/70">Resonance</li>
              <li className="text-porcelain-white/70">The Library</li>
              <li className="text-porcelain-white/70">Zen Search</li>
            </ul>
          </div>

          {/* Alliance / Network */}
          <div>
            <div className="text-xs font-mono tracking-widest text-porcelain-white/50 uppercase">
              Our Network
            </div>
            <a
              href="https://chinesename.shop"
              target="_blank"
              rel="noopener noreferrer"
              className="mt-3 inline-flex items-center text-sm text-amber-200/90 hover:text-amber-200 transition-colors"
            >
              ChineseName.shop
            </a>
            <p className="mt-2 text-sm text-porcelain-white/60">
              Discover your authentic Eastern identity &amp; name.
            </p>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-white/10 flex flex-col sm:flex-row gap-3 sm:gap-6 items-start sm:items-center justify-between">
          <p className="text-xs text-porcelain-white/50">
            © {new Date().getFullYear()} Wisdom Nexus. All rights reserved.
          </p>
          <p className="text-xs text-porcelain-white/40">
            Built for calm discovery — part of a larger ecosystem of cultural products.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;

